import LeanBar from '@/components/ui/LeanBar'
import { countsOf, selectionCoverage } from '@/components/ui/SelectionLabel'

// The row mark: how every LIST row on the site shows a story's lean (Sam,
// 2026-11-01: "too many variations"). The 6px three-part bar and Pano's
// label under it (Balanced, Mostly Right…), nothing else: in a row the
// label is the answer, and the counts wait on the story's page (Sam, the
// same day, after trying counts at the bar's ends and then a counts line
// under it). The timeline mark (LeanTimeline) ends the same way. A page's
// own coverage is the other pattern (CoverageBlock: the counts over each
// segment).
//
// Give it a story `node` or `counts` ({ left, center, right }). `label`
// replaces the verdict where a list wants a figure instead, in
// `labelClassName`; `showLabel={false}` drops the line (a compact row, a
// phone's meta line that prints the label beside it).

export default function LeanMark({
  node,
  counts,
  label,
  labelClassName = 'text-foreground',
  showLabel = true,
  className = '',
}) {
  const [left, center, right] = counts
    ? [counts.left || 0, counts.center || 0, counts.right || 0]
    : countsOf(node)
  const text = showLabel
    ? (label ?? selectionCoverage(node ?? { lean: counts || {} })?.text ?? null)
    : null
  const labelLine = text && (
    <span
      className={`mt-[5px] block font-sans text-[11px] font-semibold leading-none tabular-nums sm:text-xs ${labelClassName}`}
      title="Pano’s rating of who covered it"
    >
      {text}
    </span>
  )

  // No counts (old edition rows): the bar in the label's colour, no ends.
  if (!left && !center && !right) {
    return (
      <span className={`block ${className}`}>
        <LeanBar node={node} counts={counts} className="w-full" />
        {labelLine}
      </span>
    )
  }

  return (
    <span className={`block ${className}`}>
      <LeanBar node={node} counts={counts} className="w-full" />
      {labelLine}
    </span>
  )
}
